import React from 'react'
import bgimg from "../../assets/images/auth.jpg"
import "../../styles/pages/auth/signUp.scss"

const AuthBg = () => {
    return (
        <div className='signup-content'>
            <div className="image-overlay"></div>
            <img
                src={bgimg}
                alt="sign-up img"
                className="h-100 w-100 signup-image"
            />
        </div>
    )
}

export default AuthBg
